import { Alert, Button } from '@mui/material';
import { format } from 'date-fns';
import { FC, memo, useState } from 'react';
import { useImportPendingDeletionCandidatesQuery } from 'src/hooks/useImportDeletionCandidates.query';

import { DeletionCandidatesDialog } from './DeletionCandidatesDialog';

/**
 * 上書き取込で「取込ファイルに無い案件」が残っていることを案件一覧の上に出す（#405 決定 6）。
 *
 * 出る: 未処理（status: pending）の候補を持つ取込があるとき。ログイン会社（切替中は選択中の会社）
 * 単位なので、取込をした本人でなくても見える。候補は取込の行に残るので、取込直後にこの画面を
 * 開いていなくても翌日に出る。
 * 消える: ダイアログで全件を「削除する」か「残す」に決めたときだけ。一部だけ処理したら
 * 残りの件数で出続ける。
 *
 * Why not × ボタン・「あとで」: 決定 6 は「承認して削除する」なので、未処理のまま
 * 忘れられるのが一番困る。すぐ片付けたくないときは「すべて残す」で消す
 */
export const DeletionCandidatesBanner: FC = memo(() => {
  const pending = useImportPendingDeletionCandidatesQuery(true);
  const [open, setOpen] = useState(false);

  const data = pending.data;
  if (!data?.importId || data.count === 0) return null;

  const importedAt = data.createdAt ? format(new Date(data.createdAt), 'M/d HH:mm') : '';
  const allocatedPart = data.allocatedCount > 0 ? `（うち配車済み ${data.allocatedCount} 件）` : '';

  return (
    <>
      <Alert
        severity="warning"
        action={<Button color="inherit" size="small" onClick={() => setOpen(true)}>確認する</Button>}
      >
        {`${importedAt} の取込に無い案件が ${data.count} 件あります${allocatedPart}`}
      </Alert>
      <DeletionCandidatesDialog
        open={open}
        importId={data.importId}
        importedAt={data.createdAt}
        ruleName={data.ruleName}
        onClose={() => setOpen(false)}
      />
    </>
  );
});
